import React from 'react';
import {
  OverlayTrigger,
  Popover as BsPopover,
  PopoverBody,
} from 'react-bootstrap';
import { OverlayTriggerType } from 'react-bootstrap/esm/OverlayTrigger';
import { Placement } from 'react-bootstrap/esm/types';

export type customPopoverProps = React.PropsWithChildren<{
  trigger?: OverlayTriggerType | OverlayTriggerType[];
  popoverBody: React.ReactNode;
  placement: Placement;
  rootClose?: boolean;
  bsPrefix?: string;
}>;

// Wrapping the 'children' property in <div> ensures that OverlayTrigger has an element it can attach a ref to.
const Popover = ({
  trigger = 'click',
  placement,
  popoverBody,
  children,
  rootClose = true,
  bsPrefix,
}: customPopoverProps) => {
  
  return (
    <OverlayTrigger
      trigger={trigger}
      placement={placement}
      overlay={
        <BsPopover bsPrefix={bsPrefix}>
          <PopoverBody>{popoverBody}</PopoverBody>
        </BsPopover>
      }
      rootClose={rootClose}
    >
      <div>{children}</div>
    </OverlayTrigger>
  );
};

export default Popover;
